// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1gbzh","modalFooterButton":"ModalNotes_modalFooterButton__j41vr"};